<template>
  <div id="bookDetails">
    <div class="bookDetails">
      <div class="left_Title">
        <p>
          <i class="iconfont iconjieguo"></i>
          <span class="aqt_lang_mn titlefont">{{ $t('m.details') |U2M }}</span>
        </p>
        <p></p>
      </div>
      <!--      详情-->
      <div class="book_brief">
        <div class="pdfButton"><img v-if="infosData&&infosData.annex>0" @click="showSelectPdf"  src="@/assets/images/pdf.png"></div>
        <div class="left_brief">
          <div class="img_banner">
            <Carousel>
              <CarouselItem v-for="(item,index) in imgList" :key="index">
                <el-image
                    :src="item.images"
                    :preview-src-list="srcList">
                </el-image>
              </CarouselItem>
            </Carousel>
            <div v-if="infosData&&infosData.annex>0" class="label">PDF</div>
          </div>
          <div class="books_info" v-if="infosData">
            <div class="title" v-if="infosData.namelang&&(infosData.namelang.mn||infosData.namelang.zh)">
              <p class="titlefont" :class="(infosData.namelang&&infosData.namelang.mn)?'aqt_lang_mn':((infosData.namelang&&infosData.namelang.zh)?'aqt_su':'aqt_lang_mn')">
                {{
                  infosData.namelang&&infosData.namelang.mn?infosData.namelang.mn:(infosData.namelang&&infosData.namelang.zh?infosData.namelang.zh:'') | U2M
                }}</p>
            </div>

            <div class="aqt_zhengzhuang">
              <p class="aqt_lang_mn contentfont">{{ $t('m.booksNumber')|U2M }}: {{
                  infosData.isbn ? infosData.isbn : '' | U2M
                }}</p>
            </div>
            <div class="aqt_zhengzhuang">
              <p @click="getPress(infosData.presslang?(infosData.presslang.mn || infosData.presslang.zh):'',infosData.press_id)"
                 class="press_name contentfont aqt_lang_mn"
                 >{{ $t('m.press')|U2M }}
                : <span class="pressName" :class="(infosData.presslang&&infosData.presslang.mn)?'aqt_lang_mn':((infosData.presslang&&infosData.presslang.zh)?'aqt_su':'aqt_lang_mn')">{{
                    infosData.presslang&&infosData.presslang.mn?infosData.presslang.mn:(infosData.presslang&&infosData.presslang.zh?infosData.presslang.zh:'')|U2M
                  }}</span></p>
            </div>
            <div class="aqt_zhengzhuang" v-if="infosData.authorlang&&(infosData.authorlang.mn||infosData.authorlang.zh)">
              <p class=" contentfont aqt_lang_mn" >{{ $t('m.book_paper_author') + $t('m.Chinese_Mongolian')|U2M }} :
                <span :class="(infosData.authorlang&&infosData.authorlang.mn)?'aqt_lang_mn':((infosData.authorlang&&infosData.authorlang.zh)?'aqt_su':'aqt_lang_mn')">
                  {{
                    infosData.authorlang&&infosData.authorlang.mn?infosData.authorlang.mn:( infosData.authorlang&&infosData.authorlang.zh?infosData.authorlang.zh:'')|U2M
                  }}
                </span>

              </p>
            </div>
            <!--            <div class="aqt_zhengzhuang" v-if="infosData.author_lang && infosData.author_lang.zh">-->
            <!--              <p class="aqt_su contentfont"><span class="aqt_lang_mn contentfont">{{ $t('m.book_paper_author') + $t('m.chinese')|U2M }}</span> :-->
            <!--                {{-->
            <!--                  infosData.author_lang.zh-->
            <!--                }}-->
            <!--              </p>-->
            <!--            </div>-->

            <div class="aqt_zhengzhuang">
              <p class="aqt_lang_mn contentfont">{{ $t('m.publish_time')|U2M }} :
                {{ infosData.publish_date ? infosData.publish_date : '' | U2M }}</p>
            </div>
            <div class="aqt_zhengzhuang">
              <p class="aqt_lang_mn contentfont">{{ $t('m.pages_number')|U2M }}:
                {{ infosData.page ? infosData.page : '' | U2M }}</p>
            </div>
            <div class="aqt_zhengzhuang">
              <p class="aqt_lang_mn contentfont">{{ $t('m.words_number')|U2M }}:
                {{ infosData.word_count ? infosData.word_count : '' | U2M }}</p>
            </div>
            <div class="aqt_zhengzhuang">
              <p class="aqt_lang_mn contentfont">{{ $t('m.Price')|U2M }}: {{
                  infosData.price ? infosData.price : ''
                }}</p>
            </div>
          </div>
        </div>
        <div class="right_brief"  v-if="(infosData.contentlang&&infosData.contentlang.mn)||(infosData.contentlang&&infosData.contentlang.zh)">
          <p class="contentfont" :class="infosData.contentlang.mn?'aqt_lang_mn':(infosData.contentlang.zh?'aqt_su':'aqt_lang_mn')"
             v-html="infosData.contentlang.mn?U2M(infosData.contentlang.mn):(infosData.contentlang.zh?infosData.contentlang.zh:'')"></p>
        </div>
      </div>
      <!--      pdf-->
      <div class="book_pdflist" v-if="pdfList.length">
        <div class="_Title">
          <p>
            <i></i>
            <span class="aqt_lang_mn titlefont">{{ $t('m.Ebook') |U2M }}</span>
          </p>
        </div>
        <div class="_pdflist">
          <div class="list__pdflist" @click="annexChange(item)" v-for="(item,index) in pdfList" :key="index">
            <p class="aqt_lang_mn contentfont">
              {{ item.name ? item.name : '' | U2M }}
            </p>
            <p class="aqt_lang_mn contentfont">{{ change(item.size) }}</p>
          </div>
        </div>
      </div>
      <!--      目录-->
      <div class="book_catalogue" v-if="catalogueList.length">
        <div class="_Title">
          <p>
            <i></i>
            <span class="aqt_lang_mn titlefont">{{ $t('m.mulan') |U2M }}</span>
          </p>
        </div>
        <div class="_catalogue">
          <div
              :style="{background:directoryId==item.directory_id?'rgba(0, 0, 0, 0.1)':'',color:directoryId==item.directory_id?'var(--themeColor)':''}"
              class="list_catalogue" v-for="(item,index) in catalogueList" :key="index">
            <p class="aqt_lang_mn contentfont" v-html="U2M(item.titlelang.mn)"></p>
            <p v-if="item.page" class="aqt_lang_mn contentfont">({{ item.page ? item.page : '' }})</p>
          </div>
        </div>
      </div>
      <!--      有声书-->
      <div class="book_raudio" v-if="audioList.length">
        <div class="_Title">
          <p>
            <i></i>
            <span class="aqt_lang_mn titlefont">{{ $t('m.audiobooks') |U2M }}</span>
          </p>
        </div>
        <div class="_raudio">
          <div class="list_raudio" v-for="(item,index) in audioList" :key="index">
            <p class="aqt_lang_mn contentfont" v-html="U2M(item.name?item.name:'')"></p>
            <p class="aqt_lang_mn contentfont">
              {{ item.voratime ? item.voratime : '00:00' }}
            </p>
            <p class="aqt_lang_mn contentfont"
               v-html="U2M(item.reader_name ? item.reader_name.mn ? item.reader_name.mn : item.reader_name.zh : '')"></p>
            <p class="aqt_lang_mn contentfont">
              {{ item.size ? change(item.size) : '0' }}
            </p>
          </div>
        </div>
      </div>

      <!--    加载动画-->
      <AqtSpin v-if="isSpin"></AqtSpin>
      <file_preview style="display:none" :file_name="url" ref="file_preview"></file_preview>
    </div>
<!--    <goback style="top:30px!important;right: 90px!important;"></goback>-->
  </div>
</template>
<script>
import store from "@/store";

export default {
  props: {
    infoId: {
      type: [String, Number],
      default: ''
    },
    directoryId:{
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      isSpin: false,
      isSpin_press: false,
      imgList: [],
      srcList: [],
      audioList: [],
      pdfList: [],
      catalogueList: [],
      infosData: '',
      url: '',//pdf路径
      pressData: {
        name: '',//出版社名称
        address: '',//详细地址
        content: '',//出版社简介
        address_name: '',//地区
      },
    }
  },
  methods: {
    //  获取详情
    getbookDetails() {
      const _this = this;
      _this.isSpin = true
      let condition = {
        member_id: _this.member_id,
        book_id: _this.infoId,
        library_id: _this.library_id,

        terminal: _this.$terminal,
        wificode: _this.$store.getters.wificode,// Wi-Fi码
        network: _this.$store.getters.network,// 网络
        devicecode: _this.$store.getters.uuid,//设备码,
        latlon: _this.$store.getters.latlon,// 经纬度
      }
      _this.$httpsencrypt.post(`api/web/v3/book/findbook`, condition)
          .then((val) => {
            if (val.code == 200 && val.data) {
              _this.infosData = val.data
              // //轮播图
              _this.getIntors()
              //pdf
              // if (val.data.annex > 0) {
              //   _this.showSelectPdf()
              // }
              //目录
              _this.getCatalogue()
              //判断是否有音频
              _this.getIcon()


            } else {
              _this.isSpin = false
            }
          }).catch(e => {
        _this.isSpin = false
      })
    },
    //判断是否有音频
    getIcon() {
      let _this = this
      let cond = {
        book_id: _this.infoId,
      }
      _this.$httpsencrypt.post(`api/web/v3/book/isglother`, cond)
          .then((val) => {
            //isvideos 视频 0未关联 大于0已关联
            //isaudiojd 精读 0未关联 大于0已关联
            //isaudiojj 精讲 0未关联 大于0已关联

            if (val.code == 200) {
              //精讲
              if (val.data.isaudiojj > 0) {
                _this.getAydio()
              }
              //精读
              if (val.data.isaudiojd > 0) {

              }
            }

          })
    },
    //获取pdf
    showSelectPdf() {
      let that = this
      that.isSpin = true
      let condition = {
        model: 'Book',
        filetype: 'File',
        level: 'AQT_2023_1',
        id: that.infoId,
        type1: 1,
        name: '书籍详情pdf按钮',
      }
      that.pdfList = [];
      that.$getResources(condition).then(val => {
        if (val.code == 200) {
          that.pdfList = val.data.map((item) => {
            let bb = {
              type: item.type,
              url: item.url ? that.$webcrypto.get(item.url) : '',
              name: item.name,
              size: item.size,
              videopic: item.videopic,
              voratime: item.voratime,
              lx: item.lx,
              id: item.resources_id,
            }
            return bb;
          })
        } else {
          that.$Message.warning({
            content: val.message
          })
        }
        that.isSpin = false
      }).catch((err) => {
        that.isSpin = false
      });
    },
    //  获取目录
    getCatalogue() {
      const _this = this;
      let cond = {
        book_id: _this.infoId,
        type: 1,//1.书目录 2.期刊目录 3报刊 4普通论文
        member_id: _this.member_id,
        library_id: _this.library_id,
terminal: _this.$terminal,

        wificode: _this.$store.getters.wificode,// Wi-Fi码
        network: _this.$store.getters.network,// 网络
        devicecode: _this.$store.getters.uuid,//设备码,
        latlon: _this.$store.getters.latlon,// 经纬度
      }
      _this.$httpsencrypt.post(`api/web/v3/directory/newindex`, cond)
          .then((val) => {
            _this.catalogueList = [];
            _this.handelSlugData(val.data, 0);
            _this.isSpin = false
          }).catch((err) => {
        _this.isSpin = false
        _this.catalogueList = [];
      });
    },
    //获取多图
    getIntors() {
      const _this = this
      _this.items = []
      let condition = {
        model: 'Book',
        filetype: 'Image',
        level: 'AQT_2023_2',
        id: _this.infoId,
        type1: 1,
        name: '书籍详情多图',
      }
      _this.$getResources(condition).then((val) => {
        if (_this.infosData.imgm) {
          _this.srcList.push(_this.$webcrypto.get(_this.infosData.imgm))
          let a = {
            images: _this.$webcrypto.get(_this.infosData.imgm)
          }
          _this.imgList.push(a)
        }

        if (val.code == 200 && val.data.length) {
          val.data.forEach(item => {
            let b = {
              images: _this.$webcrypto.get(item)
            }
            _this.imgList.push(b)
            _this.srcList.push(_this.$webcrypto.get(item))
          });
        }
      }).catch((err) => {
      });

    },
    //获取音频
    getAydio() {
      const _this = this;
      _this.audioList = []
      let cond = {
        read_type:1,
        book_id:_this.infoId,
        member_id: _this.member_id
      }
      _this.$httpsencrypt.post(`api/web/v3/audiobook/audiobookindex`, cond)
          .then((val) => {
            if (val.data.length) {
              _this.audioList=[]
              val.data.forEach(it=>{
                if(it.aulist.length){
                  it.aulist.forEach(kk=>{
                    _this.audioList.push({
                      ...kk,
                      ...it
                    })
                  })
                }
              })

            } else {
              _this.audioList = []
            }
          }).catch((err) => {
        _this.readList = []
        _this.audioList = []
      });
    },
    /************************************************************
     *
     * 处理数据格式
     *
     ************************************************************/
    handelSlugData(data, label) {
      const title = label
      data.map((el, ind) => {
        el.titlelang.mn = (el.titlelang.mn ? `<p class="aqt_lang_mn contentfont" style="height:calc(100% - ${title}px);margin-top:${title}px;"> ${el.titlelang.mn}</p>` : `<p class="aqt_lang_mn contentfont" style="height:calc(100% - ${title}px);margin-top:${title}px;"> ${el.titlelang.zh}</p>`)
        this.catalogueList.push(el)
        let label = title + 20
        if (el.child.length !== 0) this.handelSlugData(el.child, label)
      })
    },


    change(limit) {
      var size = "";
      if (limit < 0.1 * 1024) {                            //小于0.1KB，则转化成B
        size = limit.toFixed(2) + "B"
      } else if (limit < 0.1 * 1024 * 1024) {            //小于0.1MB，则转化成KB
        size = (limit / 1024).toFixed(2) + "KB"
      } else if (limit < 0.1 * 1024 * 1024 * 1024) {        //小于0.1GB，则转化成MB
        size = (limit / (1024 * 1024)).toFixed(2) + "MB"
      } else {                                            //其他转化成GB
        size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB"
      }

      var sizeStr = size + "";                        //转成字符串
      var index = sizeStr.indexOf(".");                    //获取小数点处的索引
      var dou = sizeStr.substr(index + 1, 2)            //获取小数点后两位的值
      if (dou == "00") {                                //判断后两位是否为00，如果是则删除00
        return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
      }
      return size;
    },
    //查看pdf
    annexChange(data) {
      this.url = data.url
      setTimeout(() => {
        this.$refs.file_preview.preview();
        this.saveUserBehavior(34,'书籍详情pdf资源查看',data.id)
      }, 500)
    },
    saveUserBehavior(type, mark, id) {
      let that = this
      let info = {
        book_id: id,
        magazine_id: null,
        type: type,
        path: this.$route.path,
        mark: mark,
      }
      that.$store.dispatch('saveUserBehavior', info).then(() => {
      })
    },
    //  显示出版社数据
    getPress(val, id) {
      let that = this
      that.$router.push(
          {
            path: '/BooksList',
            query: {
              lib_type:sessionStorage.getItem('gcm'),
              typeClass: that.$crypto.set(1),
              qActive: that.$crypto.set(4),
              searchContent: val ? that.$crypto.set(JSON.stringify(val)) : '',
              title_left: that.$crypto.set(JSON.stringify(that.$t('m.press'))),
              untype: '',
              press_id: id ? that.$crypto.set(id) : ''
            }
          }
      )
    },
  },
  created() {
    this.getbookDetails()
    let info={
      book_id: this.infoId,
      type: 1,
      path: this.$route.path,
      mark: '书籍详情',
    }
    this.$store.dispatch('saveUserBehavior', info).then(() => {
    })
  },
  computed: {
    // 馆藏id
    library_id() {
      let vv = localStorage.getItem("theme_color") ? JSON.parse(this.$crypto.get(localStorage.getItem("theme_color"))).library_id : "";
      return vv
    },
    // 用户id
    member_id() {
      let mm = localStorage.getItem("userInfoMemberId") ? JSON.parse(this.$crypto.get(localStorage.getItem("userInfoMemberId"))).member_id : ''
      return mm
    },
  }
}
</script>

<style lang="less" scoped>
#bookDetails {
  width: 100%;
  height: 100%;
  display: flex;

  .bookDetails {
    width: 100%;
    height: 100%;
    display: flex;
    overflow-x: auto;
    position: relative;

    .left_Title {
      min-width: 54px;
      height: 100%;
      background: #ffffff;
      margin-right: 2px;
      padding-top: 27px;
      display: flex;
      justify-content: flex-end;

      p:nth-child(1) {
        width: 24px;
        color: var(--themeColor);
        font-size: 20px;
        line-height: 24px;

        i {
          font-size: 24px;
        }
      }

      p:nth-child(2) {
        width: 4px;
        height: 162px;
        background: var(--themeColor);
        margin-left: 10px;
      }
    }

    ._Title {
      width: 54px;
      height: 100%;
      background: #ffffff;
      margin-right: 2px;
      padding-top: 35px;
      display: flex;
      justify-content: center;
      color: #888888;

      p:nth-child(1) {
        width: 24px;
        font-size: 20px;
        line-height: 24px;

        i {
          display: block;
          width: 27px;
          height: 13px;
          background: var(--themeColor);
          margin-bottom: 14px;
        }
      }
    }

    .book_brief {
      //min-width: 200px;
      height: 100%;
      background: #ffffff;
      margin-right: 10px;
      padding: 27px 10px;
      display: flex;
      position: relative;
      .pdfButton{
        width: 50px;
        height: 50px;
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
          width: 30px;
          height: auto;
          cursor: pointer;
        }
      }

      .left_brief {
        min-width: 180px;
        height: 100%;
        padding-top: 20px;

        .img_banner {
          width: 180px;
          height: 270px;
          margin: 0 auto;
          position: relative;
          overflow: hidden;
          padding-top: 20px;

          img {
            width: 180px;
            height: 100%;
            border-radius: 5px;
          }

          .label {
            line-height: 24px;
            height: 20px;
            height: 20px;
            background: red;
            color: #fff;
            font-size: 12px;
            position: absolute;
            right: 0;
            top: 0;
            z-index: 2;
            padding: 0 15px;
            -webkit-transform-origin: left bottom;
            -moz-transform-origin: left bottom;
            transform-origin: left bottom;
            -webkit-transform: translate(29.29%, -100%) rotate(45deg);
            -moz-transform: translate(29.29%, -100%) rotate(45deg);
            transform: translate(29.29%, -100%) rotate(45deg);
            text-indent: 0;
          }
        }

        .books_info {
          display: flex;
          min-width: 180px;
          padding-top: 10px;
          height: calc(100% - 270px);

          .title {
            height: 100%;
            color: #888888;
            font-size: 1.8rem;
            margin: 0 0.3rem;

            p {
              word-wrap: break-word;
              word-break: normal;
              height: 100%;
            }
          }

          .aqt_zhengzhuang {
            height: 100%;
            color: #888888;
            font-size: 1.2rem;
            margin: 0 .3rem;

            p {
              font-size: 1.6rem;
              word-wrap: break-word;
              word-break: normal;
              height: 100%;
              color: #888888;
            }

            .pressName:hover {
              color: var(--themeColor) !important;
            }
          }

          .press_name {
            cursor: pointer;
          }

        }
      }

      .right_brief {
        min-width: 50px;
        height: 100%;
        color: #888888;
        font-size: 1.8rem;
        margin: 0 0.3rem;

        p {
          word-wrap: break-word;
          word-break: normal;
          height: 100%;
        }
      }
    }

    .book_catalogue {
      height: 100%;
      margin-right: 10px;
      display: flex;

      ._catalogue {
        height: 100%;
        padding: 30px 10px;
        display: flex;
        background: #ffffff;

        .list_catalogue {
          height: 100%;
          color: #888888;
          font-size: 1.8rem;
          margin: 0 0.3rem;
          padding: 5px 0;

          p:nth-child(1) {
            height: 92%;
          }

          p:nth-child(2) {
            height: 8%;
            text-align: center;
            margin: 0 auto;

          }
        }

        .list_catalogue:hover {
          background: rgba(0, 0, 0, 0.1);
        }
      }


    }

    .book_raudio {
      height: 100%;
      margin-right: 10px;
      display: flex;

      ._raudio {
        height: 100%;
        padding: 30px 10px;
        display: flex;
        background: #ffffff;

        .list_raudio {
          height: 100%;
          color: #888888;
          font-size: 1.8rem;
          margin: 0 0.3rem;
          padding: 5px 0;

          p:nth-child(1) {
            height: 62%;
          }

          p:nth-child(2) {
            height: 10%;
            margin: 0 auto;
            color: #888888;
            text-align: center;
          }

          p:nth-child(3) {
            height: 15%;
            margin: 0 auto;
            color: #888888;
            text-align: center;
          }

          p:nth-child(4) {
            height: 13%;
            margin: 0 auto;
            color: #888888;
            text-align: center;
          }
        }

        .list_raudio:hover {
          background: rgba(0, 0, 0, 0.1);
        }
      }
    }

    .book_pdflist {
      height: 100%;
      margin-right: 10px;
      display: flex;

      ._pdflist {
        height: 100%;
        padding: 35px 17px;
        display: flex;
        background: #ffffff;

        .list__pdflist {
          height: 100%;
          color: #888888;
          font-size: 1.8rem;
          margin: 0 0.3rem;
          //background: #F2F7FF;
          background: #eeeeee;
          padding: 10px;
          cursor: pointer;

          p:nth-child(1) {
            height: 85%;
          }

          p:nth-child(2) {
            height: 15%;
            text-align: center;
          }
        }

        .list__pdflist:hover {
          color: var(--themeColor);
        }
      }
    }
  }

  .bookDetails::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 12px;
  }

  .bookDetails::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .bookDetails::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }

}
</style>

<style lang="less">
#bookDetails {
  .ivu-carousel {
    height: 100% !important;

    .ivu-carousel-list {
      height: 100% !important;

      .ivu-carousel-track {
        height: 100% !important;

        .ivu-carousel-item {
          height: 100% !important;
        }
      }
    }
  }

  .ivu-carousel-dots li button {
    opacity: unset !important;
    width: 5px !important;
    height: 5px !important;
    border-radius: 50%;
  }

  .ivu-carousel-dots li.ivu-carousel-active > button {
    opacity: unset !important;
    background: var(--themeColor);
  }

  .ivu-carousel-dots-inside {
    bottom: 15px !important;
  }

}
</style>
